// src/api/clientService.js
import { apiFetch } from "./http";
import { API_ENDPOINTS } from "../config";

const toSnake = (data) => ({
  first_name: data.firstName,
  last_name: data.lastName,
  email: data.email || null,
  phone: data.phone || null,
  client_type: data.clientType || null,
  lead_source: data.leadSource || null,
  stage: data.stage || null,
  notes: data.notes || null,
  birthday: data.birthday || null,
  anniversary: data.anniversary || null,
});

export const clientService = {
  async list() {
    const res = await apiFetch(API_ENDPOINTS.CLIENTS);
    if (!res.ok) throw new Error("Failed to load clients");
    return res.json();
  },

  async create(data) {
    const res = await apiFetch(API_ENDPOINTS.CLIENTS, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(toSnake(data)),
    });
    const json = await res.json();
    if (!res.ok) throw Object.assign(new Error(json.detail || "Failed to create client"), { status: res.status, data: json });
    return json;
  },

  async update(clientId, data) {
    const res = await apiFetch(`${API_ENDPOINTS.CLIENTS}${clientId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(toSnake(data)),
    });
    const json = await res.json();
    if (!res.ok) throw Object.assign(new Error(json.detail || "Failed to update client"), { status: res.status, data: json });
    return json;
  },

  async delete(clientId, force = false) {
    const res = await apiFetch(`${API_ENDPOINTS.CLIENTS}${clientId}?force=${force}`, {
      method: "DELETE",
    });
    const json = await res.json();
    if (!res.ok) throw Object.assign(new Error(json.detail || "Failed to delete client"), { status: res.status, data: json });
    return json;
  },

  async getRelated(clientId) {
    const res = await apiFetch(`${API_ENDPOINTS.CLIENTS}${clientId}/related`);
    if (!res.ok) throw new Error("Failed to load related info");
    return res.json();
  },
};
